export interface CartTestSubtotalInput {
  totalInCents: number;
  taxInCents: number;
  /** coupon credits, gift card and account balance: what the cart test counts as promo savings */
  promoDiscountInCents: number;
  /** shown in its own pill and taken off the final price, not struck through */
  positionDiscountSavingsInCents: number;
  waivedActivationFeesInCents: number;
  ultraHardwareDiscountInCents: number;
  /** a GwP partner free trial's gift ($99 kit + its months), which the server never subtracts */
  partnerFreeTrialGiftInCents: number;
}

/**
 * The bag's cart-test subtotal: the struck-through price before savings, the price paid, and the "$X SAVED" badge.
 * Kept in one place so the three always add up.
 */
export function cartTestSubtotal(input: CartTestSubtotalInput) {
  const otherDiscountsInCents =
    input.promoDiscountInCents +
    input.waivedActivationFeesInCents +
    input.ultraHardwareDiscountInCents +
    input.partnerFreeTrialGiftInCents;
  const totalWithoutTaxInCents = input.totalInCents - input.taxInCents;
  return {
    showStrikethrough: otherDiscountsInCents > 0 || input.positionDiscountSavingsInCents > 0,
    strikethroughInCents:
      otherDiscountsInCents > 0 ? totalWithoutTaxInCents + otherDiscountsInCents : totalWithoutTaxInCents,
    finalInCents: totalWithoutTaxInCents - input.positionDiscountSavingsInCents,
    savingsForBadgeInCents: otherDiscountsInCents + input.positionDiscountSavingsInCents,
  };
}
